import { render, staticRenderFns } from "./load.vue?vue&type=template&id=4d377752&scoped=true&"
import script from "./load.vue?vue&type=script&lang=js&"
export * from "./load.vue?vue&type=script&lang=js&"
import style0 from "./load.vue?vue&type=style&index=0&id=4d377752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d377752",
  null
  
)

export default component.exports